import axios, { AxiosRequestConfig, AxiosError, AxiosResponse } from 'axios';

import { hanleError, notify } from './handler';
import { isIgnoreError } from './utils';
import {
  CancelError,
  TimeoutError,
  NetworkError,
  IgnoreError,
  AuthorizationError,
  TCMError,
  UnknowError,
  BaseError,
} from './error';

export interface TokenGenerator {
  (): Promise<string>;
}

export async function onHttpRequest(config: AxiosRequestConfig, getAccessToken: TokenGenerator) {
  try {
    const accessToken = await getAccessToken();
    if (accessToken) {
      return {
        ...config,
        headers: {
          ...config.headers,
          Authorization: `Bearer ${accessToken}`,
        },
      };
    }
  } catch (error) {}
  return config;
}

export function onHttpResponseResolve(response: AxiosResponse) {
  return response;
}

export function onHttpResponseReject(e: AxiosError<{ code?: string; message?: string } | undefined>) {
  if (!axios.isAxiosError(e)) return Promise.reject(e);

  let error: BaseError;

  const url = e.request?.responseURL || `${e.config?.baseURL || ''}${e.config?.url}`;
  const status = `${e.response?.status || ''}`;

  if (isIgnoreError(e)) {
    error = new IgnoreError(status, IgnoreError.CODE, url, e.message, e);
  } else if (axios.isCancel(e)) {
    error = new CancelError(status, url, e.message, e);
  } else if (!e.response) {
    if (e.message.startsWith(TimeoutError.CODE)) {
      error = new TimeoutError(status, url, e.config.timeout || 5000, e);
    } else {
      error = new NetworkError(status, url, e.message, e);
    }
  } else {
    const tcmCode = e.response.data?.code || '';
    const tcmMessage = e.response.data?.message || '';
    if (/^(401)$/.test(status)) {
      error = new AuthorizationError(status, AuthorizationError.CODE_401, url, tcmMessage || e.message, e);
    } else if (tcmCode) {
      error = new TCMError(status, tcmCode, url, tcmMessage || e.message, e);
    } else if (/^(403)$/.test(status)) {
      error = new AuthorizationError(status, AuthorizationError.CODE_403, url, tcmMessage || e.message, e);
    } else {
      error = new UnknowError(status, url, tcmMessage || e.message, e);
    }
  }
  hanleError(error);
  notify(error);

  return Promise.reject(error);
}
